import ContentWrapper from "../../UI/ContentWrapper/ContentWrapper";
import Service from "./Service/Service";
import {useParams} from "react-router-dom";
import {useQuery} from "@apollo/client";
import {GET_ALL_SERVICES, SERVICE_LIST} from "../../apollo/Queries";
import {apolloClientPosBranch} from "../../apollo/ApolloClients";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {convertDateTimeForRequest} from "../../utils/workingWithDateTime/convertDateTimeForRequest";
import Spinner from "../../components/Spinner/Spinner";
import {useTranslation} from "react-i18next";
import {setBookingValidate} from "../../store/bookingValidateReducer";
import convertDateByTimezone from "../../utils/workingWithDateTime/convertDateByTimezone";
import {NavigationComponent} from "../../components/NavigationComponent/NavigationComponent";
import {DateTime} from "luxon";


const Services = () => {

    const {t: translate} = useTranslation();
    const {companyId, branchId} = useParams();
    const currentEmployer = useSelector(state => state.employeeReducer.employeeId);
    const currentDateTime = useSelector(state => state.dateReducer.currentDate);
    const dateIsEntered = useSelector(state => state.dateReducer.dateIsEntered);
    const timeZone = useSelector(state => state.branchReducer.timeZone);
    const convertedDateByTimeZone = convertDateByTimezone(timeZone);
    const dateForRequest = currentDateTime ? currentDateTime : convertedDateByTimeZone;
    const dispatch = useDispatch();
    const isBookingValid = useSelector(state => state.bookingValidateReducer.validate);
    const [loading, setLoading] = useState(true);
    const [allServiceItems, setAllServiceItems] = useState([]);

    const {data: branchServices} = useQuery(SERVICE_LIST,
        {
            client: apolloClientPosBranch,
            variables: {
                branchId: branchId,
                employeeId: currentEmployer,
                dateTime: dateIsEntered ? convertDateTimeForRequest(dateForRequest) : null,
                online: true
            }, onCompleted: () => {
                setLoading(false)
            }
        });

    const {data : otherServiceList,refetch : refetchOtherServices, loading: loadingOtherServices} = useQuery(GET_ALL_SERVICES,
        {
            client: apolloClientPosBranch,
            variables: {
                branchId: branchId,
                employeeId: currentEmployer,
                online: true,
                ignoreGap : true,
            }
        });

    const [filteredData, setFilteredData] = useState([]);

    const [input, setInput] = useState("");
    useEffect(() => {
        if (branchServices && branchServices?.services) {
            setFilteredData(branchServices?.services);
        }
        if (!isBookingValid) {
            dispatch(setBookingValidate({validate: true}))
        }
    }, [branchServices, dispatch, isBookingValid, refetchOtherServices]);

    useEffect(() => {
        if (!!branchServices) {
            refetchOtherServices().then(result => {
                const otherServices = result.data.services.filter(
                    serviceItem =>
                        !branchServices.services.some(branchItem => branchItem.id === serviceItem.id)
                );
                setAllServiceItems(otherServices);
            })
        }
    }, [branchServices, refetchOtherServices]);
    const formatDateTime = (isoString) => {
        return DateTime.fromISO(isoString, {setZone: true})
            .toFormat("HH:mm dd.MM.yy");
    };

    function handleChange(event) {
        setInput(event.target.value);
        if (event.target.value === '') {
            setFilteredData(branchServices.services);
            if (otherServiceList.services.length > 0) {
                const otherServices = otherServiceList.services.filter(
                    serviceItem =>
                        !branchServices.services.some(branchItem => branchItem.id === serviceItem.id)
                );
                setAllServiceItems(otherServices)
            }
        } else {
            const filtered = branchServices?.services.filter((item) =>
                item.serviceCategory?.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.name.toLowerCase().includes(event.target.value.toLowerCase())
            );
            const filteredOtherServices = allServiceItems.filter((item) =>
                item.serviceCategory?.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.name.toLowerCase().includes(event.target.value.toLowerCase())
            );
            setFilteredData(filtered);
            setAllServiceItems(filteredOtherServices);
        }
    }

    return (
        <>
            <NavigationComponent
                navLink={`/company/${companyId}/branch-menu-list/${branchId}`}
                linkText={translate('backToMenu')}
            />
            <div className="service-list">
                <ContentWrapper>
                    <label htmlFor="searchInput">
                        <h5 className="main_text_color mb-3">
                            {translate('servicePage.services')}
                        </h5>
                    </label>
                    <div className="input-wrapper position-relative mb-3">
                        <input type="search" className="form-control custom-search-style" id="searchInput" value={input}
                               onChange={handleChange}/>
                        <button
                            className="border-0
                         bg-white icon_to_block
                         bg-transparent
                         position-absolute
                         end-0
                         top-50
                         translate-middle-y
                         me-2">
                            <i className="bi bi-search"></i>
                        </button>
                    </div>
                </ContentWrapper>

                {(dateIsEntered && (filteredData.length > 0 || allServiceItems.length >0)) && <div className="container">
                    <h5 className={'mb-3 col-lg-8 mx-auto main_text_color'}>{translate('serviceInDate')} {formatDateTime(dateForRequest)}:</h5>
                </div>}

                {(filteredData && branchServices && branchServices.services.length !== 0 && filteredData.length !== 0) &&
                    <>
                        {
                            filteredData.map((serviceItem) => (
                                <ContentWrapper key={serviceItem.id}>
                                    <Service
                                        serviceCategory={serviceItem.name}
                                        serviceId={serviceItem.id}
                                        workPhoto={serviceItem.image}
                                        servicePrice={serviceItem.price}
                                        description={serviceItem.description}
                                        serviceTime={serviceItem.duration}
                                        currencyCode={serviceItem.currencyCode}
                                    />
                                </ContentWrapper>
                            ))
                        }
                    </>
                }

                {(filteredData.length === 0 && allServiceItems.length ===0) && <p className={"mb-3 text-secondary text-center"}>
                    {translate('servicePage.servicesNotFound')}
                </p>}
                {(filteredData.length === 0 && allServiceItems.length !==0) && <p className={"mb-3 text-secondary text-center"}>
                    {translate('emptyServiceOnThisDate')}
                </p>}

                {(dateIsEntered && allServiceItems.length > 0) && <div className="container">
                    <h5 className={'mb-3 col-lg-8 mx-auto main_text_color'}>{translate('otherServices')}:</h5>
                </div>}
                {allServiceItems.length > 0 &&
                    <>
                        {
                            allServiceItems.map((serviceItem) => (
                                <ContentWrapper key={serviceItem.id}>
                                    <Service
                                        serviceCategory={serviceItem.name}
                                        serviceId={serviceItem.id}
                                        workPhoto={serviceItem.image}
                                        servicePrice={serviceItem.price}
                                        description={serviceItem.description}
                                        serviceTime={serviceItem.duration}
                                        currencyCode={serviceItem.currencyCode}
                                        isOtherService={true}
                                    />
                                </ContentWrapper>
                            ))
                        }
                    </>
                }
                {loading || loadingOtherServices ? <Spinner/> : ''}
            </div>
        </>
    )
}

export default Services